var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLobbyGameLive = function SvgLobbyGameLive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FE0000",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.888672,
    y: 0.88916,
    width: 14.2222,
    height: 14.2222,
    rx: 7.11111,
    fill: "white",
    fillOpacity: 0.89
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.55542,
    y: 3.55591,
    width: 8.88889,
    height: 8.88889,
    rx: 4.44444,
    fill: "#FE0000",
    fillOpacity: 0.7
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLobbyGameLive);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iOCIgZmlsbD0iI0ZFMDAwMCIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPHJlY3QgeD0iMC44ODg2NzIiIHk9IjAuODg5MTYiIHdpZHRoPSIxNC4yMjIyIiBoZWlnaHQ9IjE0LjIyMjIiIHJ4PSI3LjExMTExIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjg5Ii8+CjxyZWN0IHg9IjMuNTU1NDIiIHk9IjMuNTU1OTEiIHdpZHRoPSI4Ljg4ODg5IiBoZWlnaHQ9IjguODg4ODkiIHJ4PSI0LjQ0NDQ0IiBmaWxsPSIjRkUwMDAwIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L3N2Zz4K";